/**
 * Labstep
 *
 * @module screens/Onboarding
 * @desc Onboarding page for entereprise
 */

import { FullScreenPage as LayoutFullScreenPage } from 'labstep-web/components/Layout/FullScreenPage';
import { OrganizationLogo } from 'labstep-web/components/Organization/Logo';
import ShareLinkInvitationFormCreateOrganization from 'labstep-web/components/ShareLinkInvitation/Form/Create/Organization';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { Button } from 'labstep-web/core/Button';
import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { Header } from 'labstep-web/core/Header';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './styles.module.scss';
import type { IScreensOnboardingProps } from './types';

export const ScreensOnboarding: React.FC<IScreensOnboardingProps> = ({
  authenticatedUserEntity,
  history,
}) => {
  const { organization } = authenticatedUserEntity.userOrganization!;
  return (
    <>
      <DocumentHead title="Onboarding" />
      <LayoutFullScreenPage>
        <div className={styles.centered}>
          <OrganizationLogo organization={organization} />
          <Header size="large">{organization.name}</Header>
          <Header size="small">
            Next, let&apos;s invite your colleagues.
          </Header>
        </div>
        <ShareLinkInvitationFormCreateOrganization
          organization={organization}
          options={{
            toast: true,
            onSuccess: () =>
              history.push(
                navigation.get('organization_show', {
                  identifier: organization.identifier,
                }),
              ),
          }}
          cancelButton={
            <Button
              primary
              basic
              route={{
                to: 'organization_show',
                params: { identifier: organization.identifier },
              }}
            >
              Skip
            </Button>
          }
        />
      </LayoutFullScreenPage>
    </>
  );
};

export default withAuthenticatedUserEntity(
  withRouter(ScreensOnboarding),
);
